import { addressSchema } from '@commenda/schema/address';
import { isValidPhoneNumber } from 'libphonenumber-js';
import * as z from 'zod';
import { fileSchema } from '../../../../../schema/base';

export const personalDetailsSchema = z.object({
  directorFirstName: z
    .string()
    .trim()
    .min(1, { message: 'Please enter a valid first name' }),
  directorLastName: z.string().trim().nullable(),
  number: z
    .string()
    .trim()
    .refine((value) => isValidPhoneNumber(value), {
      message: 'Please enter a valid phone number',
    }),
  email: z
    .string()
    .trim()
    .email({ message: 'Please enter a valid email address' }),
  operatingAddress: addressSchema,
  personalDetails: z.object({
    nationality: z
      .string()
      .trim()
      .min(1, { message: 'Please select nationality' }),
    isPoliticallyExposed: z.boolean().default(false),
  }),
});

export const passportInfoSchema = z.object({
  passport: fileSchema,
  personalDetails: z.object({
    haveUAEResidenceVisa: z.boolean().default(true),
    passportCountryOfIssue: z.string().min(1, 'Please select a country.'),
    passportNumber: z.string().min(5, 'Please enter a valid passport number.'),
    passportExpirationDate: z.string().min(1, 'Please select a valid date.'),
  }),
});

export const documentInfoSchema = z.object({
  residenceVisa: fileSchema,
  emiratesId: fileSchema,
  addressProof: fileSchema,
});

export type TPersonalDetailFields = z.infer<typeof personalDetailsSchema>;
export type TPassportInfoFields = z.infer<typeof passportInfoSchema>;
export type TDocumentInfoFields = z.infer<typeof documentInfoSchema>;
